export const StorageKeys = {
  // localStorage — persisted across tabs and sessions
  USER: 'user',
  THEME: 'theme',
  BOARD_PARTICIPANTS: 'boardParticipants',
  RETRO_ACTION_ITEMS_EXPANDED: 'retroboard-action-items-expanded',

  // sessionStorage — tab-specific, cleared on tab close
  GUEST: 'guest',
  CHUNK_ERROR_RELOAD: 'chunk_error_reload',
} as const;

// Per-board/session ad-hoc keys are written with these prefixes across the app
// (invite token cache, guest session id, kicked-blacklist, voluntary-leave flag).
// They are board-scoped and otherwise never cleaned up, so they accumulate unbounded —
// sweep them on logout / auth failure via clearBoardScopedStorage().
const BOARD_SCOPED_PREFIXES = ['inviteToken_', 'guest_session_', 'removed_from_', 'leaving_'];

export function clearBoardScopedStorage(): void {
  try {
    for (const store of [window.localStorage, window.sessionStorage]) {
      const toRemove: string[] = [];
      for (let i = 0; i < store.length; i++) {
        const key = store.key(i);
        if (key && BOARD_SCOPED_PREFIXES.some(prefix => key.startsWith(prefix))) {
          toRemove.push(key);
        }
      }
      toRemove.forEach(key => store.removeItem(key));
    }
  } catch {
    // Storage can be unavailable (private mode / SSR) — cleanup is best-effort.
  }
}
